import { render, staticRenderFns } from "./SelectedProductIntroductionItemPreview.vue?vue&type=template&id=510317b9&scoped=true&"
import script from "./SelectedProductIntroductionItemPreview.vue?vue&type=script&lang=js&"
export * from "./SelectedProductIntroductionItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductIntroductionItemPreview.vue?vue&type=style&index=0&id=510317b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510317b9",
  null
  
)

export default component.exports